import styles from "./radio-card.module.css";

type RadioCardProps = {
    checked: boolean;
    children: React.ReactNode;
    disabled?: boolean;
    icon?: React.ReactNode;
    name: string;
    onSelect?: (selectedValue: any) => void;
    radioPosition?: "top" | "center";
    value: any;
};
export function RadioCard({
    checked,
    children,
    disabled = false,
    icon,
    name,
    onSelect,
    radioPosition = "center",
    value,
}: RadioCardProps): JSX.Element {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!onSelect) return;
        onSelect(event.target.value);
    };

    return (
        <label
            className={`${styles.label} ${disabled ? styles.disabled : ""}`}
            style={{
                alignItems:
                    radioPosition === "center" ? "center" : "flex-start",
            }}
        >
            <input
                type="radio"
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                className={styles.radio}
            />
            <div className={styles.content}>{children}</div>
            {icon && <div className={styles.icon}>{icon}</div>}
        </label>
    );
}

export function RadioCardExpanded({
    checked,
    children,
    disabled = false,
    icon,
    name,
    onSelect,
    radioPosition = "center",
    value,
}: RadioCardProps): JSX.Element {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!onSelect) return;
        onSelect(event.target.value);
    };

    return (
        <label
            className={`${styles.label} ${disabled ? styles.disabled : ""}`}
            style={{
                alignItems:
                    radioPosition === "center" ? "center" : "flex-start",
                display: "block",
            }}
        >
            <div className={styles.inputContainer}>
                {icon && <div className={styles.icon}>{icon}</div>}
                <input
                    type="radio"
                    name={name}
                    value={value}
                    checked={checked}
                    disabled={disabled}
                    onChange={handleChange}
                    className={styles.radio}
                />
            </div>

            <div className={styles.content}>{children}</div>
        </label>
    );
}
